import Orders from "@/components/management/Orders";
import Transactions from "@/components/management/Transactions";

const OrderRoutes = [
  { path: "/orders", element: <Orders /> },
  { path: "/transactions", element: <Transactions /> },
];

export default OrderRoutes;
